import { ApiRouts } from '@/lib/routes/routes';
import { BasicProductDataResponse } from '@/types/catalog';
import { IBranch, IStore, IStoresIndustryGroup } from '@/types/stores';
import HttpCLient from '@/lib/utils/httpClient';

type StoreParmas = {
  page?: string;
  pageCount?: string;
  q?: string;
  industryId?: string;
  orderType?: string;
};

type ProductParams = {
  page?: string;
  pageCount?: string;
  search?: string;
};

class StoresAPI extends HttpCLient {
  // get all stores
  getStores = async (params?: StoreParmas) => {
    try {
      const defaultParams = {
        ...params,
        page: params?.page || '1',
        pageCount: params?.pageCount || '50',
      };

      const response = await this.get<IStore[]>(ApiRouts.stores, defaultParams, {
        next: {
          tags: ['stores'],
        },
      });

      return JSON.parse(JSON.stringify(response));
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      }
    }
  };

  // get store industries

  getStoresIndustries = async () => {
    try {
      const response = await this.get<IStoresIndustryGroup[]>(
        ApiRouts.storesIndustries,
        {},
        {
          next: {
            tags: ['stores-industries'],
          },
        },
      );

      return response;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      }
    }
  };

  // get branch details

  getBranch = async (branchId: string) => {
    try {
      const response = await this.get<IBranch>(
        ApiRouts.branch(branchId),
        {},
        {
          next: {
            tags: ['branch-details'],
          },
        },
      );

      return response;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      }
    }
  };

  // get all products for branch
  getAllProductsForBranch = async (branchId: string, params?: ProductParams) => {
    try {
      const defaultParams = {
        ...params,
        page: params?.page || '1',
        pageCount: params?.pageCount || '100',
        storeId: branchId,
        search: params?.search || '',
      };

      const response = await this.get<BasicProductDataResponse[] | any>(
        ApiRouts.allProductsForBranch(branchId),
        defaultParams,
        {
          next: {
            tags: ['products'],
          },
        },
      );
      if (response?.status === 404) {
        return [];
      }

      return response;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      }
    }
  };

  // get all products for branch with category
  getAllProductsForBranchWithCategory = async (
    branchId: string,
    categoryId: string,
    params?: ProductParams,
  ) => {
    try {
      const defaultParams = {
        ...params,
        page: params?.page || '1',
        pageCount: params?.pageCount || '1000',
      };

      const response = await this.get<BasicProductDataResponse[] | any>(
        ApiRouts.allProductsForBranchWithCategory(branchId, categoryId),
        defaultParams,
        {
          next: {
            tags: ['products'],
          },
        },
      );
      if (response?.status === 404) {
        return [];
      }
      return response ?? [];
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      }
    }
  };
}

export const storesApi = new StoresAPI();
